<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-printer-3d-nozzle</v-icon>{{$t('profile.nozzle.visuals')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <NozzleVisualForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import NozzleVisualForm from '../../components/nozzlevisual/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'NozzleVisual';

const { mapFields } = createHelpers({
  getterType: 'nozzlevisual/getField',
  mutationType: 'nozzlevisual/updateField'
});

export default {
  name: 'NozzleVisualCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    NozzleVisualForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('nozzlevisual', ['create', 'reset'])
  }
};
</script>
